import SetBasedInplayScoreboardImpl from './set-based-inplay-scoreboard.js';
import MojitoCore from 'mojito/core';
import { getPropTypes } from 'presentation/components/scoreboard/utils';

const UIView = MojitoCore.Presentation.UIView;

/**
 * A view to display a set-based in-play scoreboard.
 *
 * @class SetBasedInplayScoreboard
 * @memberof Mojito.Presentation.Components.Scoreboard
 */

/**
 * `SetBasedInplayScoreboard` component properties.
 *
 * @extends Mojito.Presentation.Components.Scoreboard.default.ScoreboardPropTypes
 * @memberof Mojito.Presentation.Components.Scoreboard.SetBasedInplayScoreboard
 */
const propTypes = { ...getPropTypes() };

export default UIView('SetBasedInplayScoreboard', SetBasedInplayScoreboardImpl, propTypes);
